import { Injectable } from '@angular/core';
import { CertificateAdapter } from '@app/adapters/certificate.adapter';
import { Certificate } from '@app/models/certifications.model';
import { environment } from '@environments/environment';
import { ApiService } from '../apiService.service';
import { KeplerCredlyBadge } from '@app/interfaces/kepler-credly.interface';

@Injectable({
  providedIn: 'root',
})
export class CertificationService {
  constructor(private apiService: ApiService, private certificateAdapter: CertificateAdapter) {}

  /**
   * Returns the Certificate badge data for a user
   * @param sfdcId returns the SalesForce Docebo User ID for a user
   * @returns the Certificate badge data for a user
   */
  getCertificates(email: string): Promise<Certificate[]> {
    if (!email) {
      return Promise.reject('No Email provided');
    }

    return this.apiService
      .post(`${environment.api.kepler.credly.url}/v2/badges`, { recipientEmail: email })
      .then((response: any) => {
        let certificates: Certificate[] = [];
        if (response && response.data && response.data.length > 0) {
          certificates = response.data.map((item: KeplerCredlyBadge) => {
            return this.certificateAdapter.adapt(item);
          });
        }
        return Promise.resolve(certificates);
      })
      .catch((error) => {
        return Promise.reject(`Error fetching certification badges: ${error?.message || error}`);
      });
  }
}
